import React from 'react';
import { Tag, Typography } from 'antd';
import type { DailyTradingAdviceResponse, WeatherBriefSection } from '@/api/weatherTradingAdvice';

const { Text } = Typography;

const sections = [
  ['solar', '光伏'],
  ['cloud', '云层'],
  ['precipitation', '降水'],
  ['wind', '风电'],
] as const;

const WeatherBriefTab: React.FC<{ data: DailyTradingAdviceResponse }> = ({ data }) => (
  <div style={{ display: 'grid', gap: 10 }}>
    {sections.map(([key, title]) => (
      <BriefSection key={key} title={title} item={data.weather_brief[key]} />
    ))}
    <section style={{ border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', padding: 14 }}>
      <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>气象局简报</div>
      <div style={{ color: '#111827', marginBottom: 6 }}>{data.weather_brief.official_bulletin.summary || '暂无摘要'}</div>
      <Text type="secondary" style={{ display: 'block', marginBottom: 6 }}>
        简报日期：{data.weather_brief.official_bulletin.date ?? '-'}
      </Text>
      <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
        {(data.weather_brief.official_bulletin.regions || []).map((region) => <Tag key={region}>{region}</Tag>)}
        {(data.weather_brief.official_bulletin.risk_tags || []).slice(0, 4).map((tag) => <Tag key={tag} color="orange">{tag}</Tag>)}
      </div>
    </section>
  </div>
);

const BriefSection: React.FC<{ title: string; item: WeatherBriefSection }> = ({ title, item }) => (
  <section style={{ border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', padding: 14 }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, flexWrap: 'wrap' }}>
      <div style={{ fontSize: 15, fontWeight: 700 }}>{title}</div>
      {item.level && <Tag>{item.level}</Tag>}
    </div>
    <div style={{ color: '#111827', marginBottom: 6 }}>{item.summary || '暂无摘要'}</div>
    <Text style={{ display: 'block', marginBottom: 6 }}>{item.trading_meaning || '暂无交易含义'}</Text>
    <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
      {(item.regions || []).map((region) => <Tag key={region}>{region}</Tag>)}
    </div>
  </section>
);

export default WeatherBriefTab;
